// import "./App.css"; 
// import AboutUs from "./pages/aboutUs";
// import { Route, Routes } from "react-router-dom";
// import TermsSection from "./pages/terms";
// import PrivacyPolicy from "./pages/privacy";
// import RefundSection from "./pages/refunds";
// import ScrollToTop from "./helper/ScrollToTop";
// import FAQPage from "./pages/FAQPage";
// import ContactUs from "./pages/contactUs";
// import { Navbar } from "./components/navbar";
// import { TrustedBy } from "./components/trustedBy";
// import { InfoCardsSection } from "./components/infoCard";
// import { FeatureShowcase } from "./components/featureshowcase";
// import { IntroductionTabs } from "./components/introductionTabs";
// import { PricingTable } from "./components/pricingTable";
// import { ActionPromoSection } from "./components/actionPromo";
// import { ServiceHighlights } from "./components/servicehighlights";
// import { ContactSection } from "./components/contacts";
// import { FAQSection } from "./components/faq";
// import { Footer } from "./components/footer";
// import { HeroAnimation } from "./components/heroAnimation";
// import CaptchaSonicChanges from "./pages/changes";
// import Partner from "./pages/Partner";
// import Presskit from "./pages/Presskit";

// function App() {
//   return (
//     <div className="bg-black/20 h-screen">
//       <ScrollToTop />
//       <Navbar />

//       <Routes>
//         <Route
//           path="/"
//           element={
//             <>
//               <HeroAnimation />
//               <TrustedBy />
//               <InfoCardsSection />
//               <FeatureShowcase />
//               <IntroductionTabs />
//               <PricingTable />
//               <ActionPromoSection />
//               <ServiceHighlights/>
//               <ContactSection />
//               <FAQSection />
//             </>
//           }
//         />

//         <Route path="/about" element={<AboutUs />} />
//         <Route path="/contact" element={<ContactUs />} />
//         <Route path="/extension" element={<ActionPromoSection />} />
//         <Route path="/pricing" element={<PricingTable />} />
//         <Route path="/partner" element={<Partner />} />
//         <Route path="/presskit" element={<Presskit />} />
//         <Route path="/terms" element={<TermsSection />} />
//         <Route path="/privacy" element={<PrivacyPolicy />} />
//         <Route path="/refunds" element={<RefundSection />} />
//         <Route path="/faq" element={<FAQPage />} />
//         <Route path="/changes" element={<CaptchaSonicChanges />} />
//       </Routes>
//       <Footer />
//     </div>
//   );
// }
// export default App;



import "./App.css";
// 1. Import 'lazy' and 'Suspense' from React
import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

import ScrollToTop from "./helper/ScrollToTop";
import { Navbar } from "./components/navbar";
import { Footer } from "./components/footer";

// 2. Statically import the HomePage component. It's the most important one.
import HomePage from "./pages/HomePage"; 

// 3. Lazily import all other page components.
// These will now be loaded only when the user navigates to their respective routes.
const AboutUs = lazy(() => import("./pages/aboutUs"));
const TermsSection = lazy(() => import("./pages/terms"));
const PrivacyPolicy = lazy(() => import("./pages/privacy"));
const RefundSection = lazy(() => import("./pages/refunds"));
const FAQPage = lazy(() => import("./pages/FAQPage"));
const ContactUs = lazy(() => import("./pages/contactUs"));
const ActionPromoSection = lazy(() => import("./components/actionPromo"));
const PricingTable = lazy(() => import("./components/pricingTable"));
const CaptchaSonicChanges = lazy(() => import("./pages/changes"));
const Partner = lazy(() => import("./pages/Partner"));
const Presskit = lazy(() => import("./pages/Presskit"));


// 4. Create a simple, lightweight fallback component for Suspense
// This will be shown to the user while the next page's code is downloading.
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
    <p>Loading...</p>
  </div>
);

function App() {
  return (
    <div className="bg-black/20 h-screen"> {/* Note: Consider if h-screen is what you want on pages with long content */}
      <ScrollToTop />
      <Navbar />

      {/* 5. Wrap your <Routes> component with <Suspense> */}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* The HomePage loads instantly as it's not lazy */}
          <Route path="/" element={<HomePage />} />

          {/* All these routes will now trigger a network request for their JS chunk on first visit */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/extension" element={<ActionPromoSection />} />
          <Route path="/pricing" element={<PricingTable />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/presskit" element={<Presskit />} />
          <Route path="/terms" element={<TermsSection />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/refunds" element={<RefundSection />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/changes" element={<CaptchaSonicChanges />} />
        </Routes>
      </Suspense>
      
      <Footer />
    </div>
  );
}
export default App;